import { delay } from "./delay";

var CryptoJS = require("crypto-js");
export const loadJson = (path:string, data:any = null):Promise<any> => {
    return new Promise(async(resolve, reject) => {
        let params:any = {
            type: "GET",
            url: path,
            success: (data:any) => {
                resolve(data);
            },
            error: (jqXHR:any, status:string, thrown:string) => {
                reject({jqXHR, status, thrown});
            },
            dataType: "json"
        };
        if(data!=null) params.data = data;
        $.ajax(params);
    });
}
export const loadJsonEnc = (path:string, c:string, data:any = null):Promise<any> => {
    return new Promise(async(resolve, reject) => {
        let params:any = {
            type: "GET",
            url: path,
            success: (data:string) => {
                var bytes  = CryptoJS.AES.decrypt(data, c);
                var decrypted = bytes.toString(CryptoJS.enc.Utf8);
                try {
                    let jsonObj = JSON.parse(decrypted);
                    resolve(jsonObj);
                } catch(e) {
                    reject(e);
                }
            },
            error: (jqXHR:any, status:string, thrown:string) => {
                reject({jqXHR, status, thrown});
            },
            dataType: "text"
        };
        if(data!=null) params.data = data;
        $.ajax(params);
    });
}